<ng-container *transloco="let t; read: 'findMyAgent.results'">
  <div class="rounded p-4" [class]="attribution.background">
    <div class="flex flex-col items-center justify-center space-y-4 md:flex-row md:space-x-4 md:space-y-0">
      <div [class]="'rounded-full border-4 p-2 pb-1 ' + attribution.text">
        <rma-icon [class]="attribution.text" glyph="thumb_up" />
      </div>
      <div class="text-center md:text-left">
        <div class="space-x-1 text-xl font-medium" [class]="attribution.text">
          <span>{{ t('ranking-attributes.blurb') }}</span>
          <span>{{ name }}?</span>
        </div>
        <span>{{ t('ranking-attributes.' + rankingAttributions[0]) }}</span>
      </div>
    </div>
  </div>
  <div class="relative flex w-full justify-center">
    <div [class]="'absolute -top-6 h-6 w-6 origin-bottom-left rotate-45 transform ' + attribution.background"></div>
    <div class="absolute z-10 -ml-3 h-6 w-6 bg-white"></div>
  </div>
</ng-container>
